const buttons = document.querySelectorAll('.right-panel__button--top');

function scroll_me() {
    console.log('button');
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

buttons.forEach(button => {
    button.addEventListener('click', scroll_me);
});